<template>
    <b-card>
        <b-row>
            <b-col md="8" lg="9">
                <h3>Gerenciar Administradores</h3>
            </b-col>
            <b-col sm="12" md="4" lg="3">
                <b-button @click="navigate('/administrador/cadastrar')" block variant="primary">
                    <i class="fa fa-plus"></i>
                    <span>Novo</span>
                </b-button>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="6" lg="6">
                <b-form-group label="Nome ou CPF:">
                    <b-form-input type="text" id="name" v-model="filtro.nomeEmailCPF"></b-form-input>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="6" lg="6">
                <b-form-group label="Perfil:">
                    <b-form-select v-model="filtro.perfil" placeholder="Tipo de Usuário" class="mb-3">
                        <option :value="null">Selecione...</option>
                        <option v-for="item in perfis" :key="item.id" :value="item.id"> {{ item.nome }}</option>
                    </b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="4" lg="3" style="padding-bottom: 5px;">
                <b-button block @click="limpar">
                    <i class="fa fa-eraser"></i>&nbsp;&nbsp;<span>Limpar filtros</span>
                </b-button>
            </b-col>
            <b-col sm="12" md="4" lg="3">
                <b-button block variant="primary" @click="carregar">
                    <i class="fa fa-search"></i>&nbsp;&nbsp;<span>Pesquisar</span>
                </b-button>
            </b-col>
        </b-row>
        <b-row><b-col>&nbsp;</b-col></b-row>
        <b-row>
            <b-col sm="12">
                <b-container fluid>
                    <span>
                        <b-col class="table-responsive">
                            <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                                class="table table-bordered table-striped table-sm">
                                <thead>
                                    <tr>
                                        <th scope="col" tabindex="0">CPF</th>
                                        <th scope="col" tabindex="0">Nome</th>
                                        <th scope="col" tabindex="0">Perfil</th>
                                        <th scope="col" tabindex="0">Situação</th>
                                        <th scope="col" tabindex="0">Ações</th>
                                    </tr>
                                </thead>

                                <tbody v-if="usuarios.length > 0">
                                    <tr class="action" v-for="usuario in usuarios" :key="usuario.id">
                                        <td tabindex="0">{{ aplicarMascara(usuario.cpf) }}</td>
                                        <td tabindex="0">{{ usuario.nome }}</td>
                                        <td tabindex="0">{{ usuario.perfil_nome }}</td>
                                        <td tabindex="0">{{ usuario.ativo ? 'Ativo' : 'Inativo' }}</td>
                                        <td style="width: 15%">
                                            <b-button class="btn btn-sm btn-secondary action" tabindex="0" title="Editar"
                                                @click="editar(usuario.id)">
                                                <i class="fa fa-pencil-square-o"></i>
                                            </b-button>

                                            <b-button class="btn btn-sm btn-secondary action" tabindex="0" title="Visualizar"
                                                @click="visualizar(usuario.id)">
                                                <i class="fa fa-search"></i>
                                            </b-button>

                                            <b-button tabindex="0" class="btn btn-sm btn-secondary action" title="Desvincular"
                                                @click="desvincular(usuario.users_perfis_conferencias_id)">
                                                <i class="fa fa-circle"></i>
                                            </b-button>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody v-else>
                                    <tr class="action">
                                        <td colspan="5" tabindex="0">Nenhum administrador cadastrado</td>
                                    </tr>
                                </tbody>
                            </table>
                        </b-col>
                        <pagination tabindex="0" v-show="usuarios.length > 0" :totalPorPagina="totalPorPagina"
                            :resource="resource"></pagination>
                    </span>
                </b-container>
            </b-col>
        </b-row>
    </b-card>
</template>
  
<script>
import Vue from 'vue'
import SessionStorage from '@/services/session-storage'

export default {
    data() {
        return {
            totalPorPagina: 10,
            paginaAtual: 1,
            filtro: {
                nomeEmailCPF: null,
                ativo: null,
                perfil: null,
                conferencia: null
            },
            status: [
                { value: true, text: 'Ativo' },
                { value: false, text: 'Inativo' }
            ],
            usuarios: [],
            campos: [
                { key: 'cpf', label: 'CPF', sortable: false },
                { key: 'nome', label: 'Nome do Usuário', sortable: false },
                { key: 'ativo', label: 'Status', sortable: false },
                { key: 'perfis', label: 'Perfil', sortable: false },
                { key: 'conferencias', label: 'Conferência', sortable: false },
                { key: 'super_usuario', label: 'Super usuário?', sortable: false },
                { key: 'id', label: 'Ações', sortable: false, tdClass: 'centro', thClass: 'centro' }
            ],
            conferencias: []
        }
    },
    mounted() {
        this.$store.dispatch('getPerfisAdministrador')
        this.carregar()
    },
    computed: {
        perfis() {
            return this.$store.state.perfil.listaAdministrador
        },
    },
    methods: {
        navigate(route) {
            this.$router.push(route)
        },
        carregar() {
            let cpf = this.filtro.nomeEmailCPF

            if (cpf && cpf.match(/\d{3}\.\d{3}\.\d{3}-\d{2}/g)) {
                while (cpf.indexOf('.') >= 0) {
                    cpf = cpf.replace('.', '')
                }
                cpf = cpf.replace('-', '')
            }

            let filtro = { nomeEmailCPF: cpf, perfil: this.filtro.perfil }
            Vue.http.post('api/usuario/buscarAdministradorLocal', filtro).then(response => {
                if (response.body.success) {
                    this.usuarios = response.body.data
                }
            })
        },
        sucesso(mensagem) {
            this.$bvToast.toast(mensagem, {
                title: 'Sucesso',
                autoHideDelay: 10000,
                appendToast: true,
                variant: 'info'
            })
        },
        editar(id) {
            this.$router.push('/administrador/' + id + '/editar')
        },
        visualizar(id) {
            this.$router.push('/administrador/' + id + '/visualizar')
        },
        desvincular(id) {
            console.log(SessionStorage.get('conferencia_atual_nome') )
            this.$bvModal.msgBoxConfirm('Deseja desvincular Administrador da conferência?', {
                noCloseOnBackdrop: true,
                centered: true,
                okTitle: 'Confirmar',
                cancelTitle: 'Cancelar'
            }).then(valor => {
                if (valor) {
                    Vue.http.delete('api/usuario/desvincular/' + id).then(response => {
                        if (response.body.success) {
                            this.carregar()
                            this.sucesso('Administrador desvinculado da conferência ' + SessionStorage.get('conferencia_atual_nome') + '!')
                        }
                    })
                }
            })
        },
        limpar() {
            this.filtro = { nomeEmailCPF: null, ativo: null, perfil: null, conferencia: null }
            this.carregar()
        },
        aplicarMascara(numero) {
            return numero.substr(0, 3) + '.' + numero.substr(3, 3) + '.' + numero.substr(6, 3) + '-' + numero.substr(9)
        }
    }
}
</script>
  


// WEBPACK FOOTER //
// src/pages/site/interna/administrador/usuariosAdministrador/Administrador.vue